















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { Field } from '@/model';
import { ElForm } from 'element-ui/types/form';
import { ChartFormData } from '@store/modules/visualize/ChartFormData';

const Store = namespace('visualize');

@Component
export default class ChartForm extends Vue {
  @Prop({
    default: [],
  })
  private fields!: Field[];

  @Prop({
    default: false,
  })
  private loadingFields!: boolean;

  private chartTypes = [
    { label: 'Line', value: 'line' },
    { label: 'Bar', value: 'bar' },
    { label: 'Area', value: 'area' },
  ];

  private yAggregations = ['Average', 'Count', 'Unique', 'Max', 'Min', 'Sum'];
  private xAggregations = ['Date Histogram', 'Date Range', 'Histogram', 'Terms'];

  @Store.State private formData!: ChartFormData;

  @Store.Action private reset!: () => void;

  private validateRules: object = {};

  mounted() {
    this.validateRules = {
      type: [{ required: true, message: this.$t('visualize.typeIsRequired'), trigger: 'change' }],
      yFieldAggregation: [{ required: true, message: this.$t('visualize.aggregationIsRequired'), trigger: 'change' }],
      xField: [{ required: true, message: this.$t('visualize.fieldIsRequired'), trigger: 'change' }],
      yField: [{ required: true, message: this.$t('visualize.fieldIsRequired'), trigger: 'change' }],
    };
  }

  private submit() {
    (this.$refs.form as ElForm).validate((valid) => {
      if (valid) {
        this.$emit('submit', this.formData);
      } else return false;
    });
  }

  @Watch('fields')
  private onFieldsChanged() {
    this.reset();
  }
}
